import useSwr from "@/core/composables/swr/useSwr";
import {dosageApi} from "@/container";

/**
 * Swr composable for fetching dosage instructions.
 */
const useDosageInstructions = () => {
    return useSwr("/dosages/instructions", () => dosageApi().dosageInstructions());
};

export default useDosageInstructions;
